// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useRef, useState, useEffect } from 'react'
import './ICDSearch.scss'
import { SearchResultItem } from './components/SearchResultItem/SearchResultItem'
import { text } from './Constants'
import { getAddedCodes } from './Utils'
import { removeEmojis } from '../../utils/common'
import lockIcon from '../../images/common/lock-account.png'

const ICDSearch = ({
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onInputChange,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  containerStyle,
  placeholder = 'Search',
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  searchResults,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onSearchResultSelect,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  willBlurList,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  addedICDCodes,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  onSearchOpened,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  isDetailsMode,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  deleteCode,
  // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
  saving,
}) => {
  const inputRef = useRef(null)
  const preventBlur = useRef(false)

  const [inputValue, setInputValue] = useState('')
  const [showResultsList, setShowResultsList] = useState(false)

  useEffect(() => {
    if (searchResults) {
      setShowResultsList(true)
      const container = document.querySelector('.icd-search-results-list-container')
      if (container) container.scrollTop = 0
    } else if (addedICDCodes?.length === 0) {
      setShowResultsList(false)
    }
  }, [searchResults])

  useEffect(() => {
    const content = document.querySelector('.icd-search-results-added-container')
    const container = document.querySelector('.icd-search-results-container')
    const searchClasses = document.getElementsByClassName('search-result-item-container')
    const searchResultsContainer = Array.prototype.map.call(searchClasses, (el) => el)
    let searchListHeight = 0
    for (let i = 0; i < searchResultsContainer.length; i += 1) {
      if (i === 5) {
        i = searchResultsContainer.length
      } else {
        // @ts-expect-error TS2571 -- MIGRATION: not approved, fix when encountered
        searchListHeight += searchResultsContainer[i].offsetHeight
      }
    }
    searchListHeight = searchListHeight || (searchResults ? 40 : 0)
    const borderHeights = addedICDCodes.length === 0 ? 0 : 3
    if (content) {
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      container.style.height = `${content.offsetHeight + searchListHeight + borderHeights}px`
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      container.style.maxHeight = `${content.offsetHeight + searchListHeight + borderHeights}px`
    } else {
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      container.style.height = `${searchListHeight + 3}px`
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      container.style.maxHeight = `${searchListHeight + 3}px`
    }
    const codeContainer = document.querySelector('.icd10-code-container')

    if (showResultsList) {
      const viewMaxHeight = isDetailsMode ? 524 : 340
      const adder = isDetailsMode ? 120 : 160
      if (viewMaxHeight < searchListHeight + adder) {
        // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
        codeContainer.style.height = `${searchListHeight + adder}px`
        // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
        codeContainer.style.maxHeight = `${searchListHeight + adder}px`
      } else {
        // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
        codeContainer.style.height = 'unset'
      }
    } else {
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      codeContainer.style.height = 'unset'
      // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
      codeContainer.style.maxHeight = isDetailsMode ? '524px' : `340px`
    }
    if (addedICDCodes.length === 0 && !searchResults) setShowResultsList(false)
  }, [addedICDCodes, showResultsList, searchResults])

  useEffect(() => {
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const clickDropHandler = (e) => {
      if (
        e.target.classList.contains('icd-search-parent-container') ||
        e.target.classList.contains('icd-search-input') ||
        e.target.classList.contains('icd-search-input-container') ||
        e.target.classList.contains('icd-search-results-container') ||
        e.target.classList.contains('search-results-checked-icon') ||
        e.target.classList.contains('search-result-check-box-container') ||
        e.target.classList.contains('search-result-checkbox-title') ||
        e.target.classList.contains('icd-search-results-added-container') ||
        e.target.classList.contains('icd-search-results-codes-added-label') ||
        e.target.classList.contains('icd-added-codes-container') ||
        e.target.classList.contains('search-result-code-added-separate-line') ||
        e.target.classList.contains('added-code-container') ||
        e.target.classList.contains('added-code-text') ||
        e.target.classList.contains('search-result-item-disabled') ||
        e.target.classList.contains('added-code-close-icon')
      )
        return
      if (showResultsList) {
        setShowResultsList(false)
        if (willBlurList) {
          willBlurList()
        }
      }
    }
    document.addEventListener('click', clickDropHandler)
    onSearchOpened(showResultsList)
    return () => document.removeEventListener('click', clickDropHandler)
  }, [showResultsList])

  // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
  const onChange = (event) => {
    const { value } = event.target

    if (value === removeEmojis(value)) {
      setInputValue(value)
      onInputChange(value)
    }
  }

  return (
    <div
      role='presentation'
      className='icd-search-parent-container'
      onMouseDown={(e) => {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        if (document.activeElement === inputRef.current && !e.target.classList.contains('icd-search-input')) {
          preventBlur.current = true
        }
      }}>
      <div className='icd-search-container' style={containerStyle}>
        <div className='icd-search-input-container' style={containerStyle}>
          <input
            className='icd-search-input'
            value={inputValue}
            disabled={saving}
            onChange={onChange}
            ref={inputRef}
            placeholder={placeholder}
            onFocus={() => {
              if (addedICDCodes.length || searchResults) {
                setShowResultsList(true)
              }
            }}
            // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
            onBlur={(e) => {
              if (preventBlur.current) {
                preventBlur.current = false
                // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
                inputRef?.current.focus()
                return
              }
              if (!showResultsList && willBlurList) {
                willBlurList()
              }
            }}
          />
        </div>
        {saving ?
          <img className='icd-search-lock-icon' src={lockIcon} alt='Locked' />
        : null}
      </div>
      <div
        className='icd-search-results-container'
        style={{
          display: showResultsList ? 'flex' : 'none',
          maxHeight: 512,
        }}>
        {showResultsList ?
          <>
            {addedICDCodes.length ?
              <div className='icd-search-results-added-container'>
                <label htmlFor='null' className='icd-search-results-codes-added-label'>
                  {text.CODES_ADDED}
                </label>
                <div className='icd-added-codes-container'>{getAddedCodes(addedICDCodes, deleteCode)}</div>
                {searchResults ?
                  <div className='search-result-code-added-separate-line' />
                : null}
              </div>
            : null}

            {searchResults ?
              searchResults.length ?
                <div className='icd-search-results-list-container'>
                  {/*
                   // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered */}
                  {searchResults.map(({ Code, IcdCodeId, Description }, index) => (
                    <SearchResultItem
                      name={Code}
                      description={Description}
                      onSelect={onSearchResultSelect}
                      id={IcdCodeId}
                      isLast={index === searchResults.length - 1}
                      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                      disabled={addedICDCodes.some((code) => code.IcdCodeId === IcdCodeId)}
                    />
                  ))}
                </div>
              : <div className='icd-search-no-results-container'>
                  <label className='icd-search-no-results-label' htmlFor='null'>
                    {text.NO_RESULTS}
                  </label>
                </div>

            : null}
          </>
        : null}
      </div>
    </div>
  )
}

export default ICDSearch
